<template>
  <div
    class="table_status"
    :class="{
                  'badge-danger': statusCalc==true,
                  'badge-success': statusCalc == false
                }"
  >{{timestamp}}</div>
</template>

<script>
import moment from "moment";
/* eslint-disable */
export default {
  name: "status-indicator",
  props: ["timestamp"],
  data: function() {
    return {
      boltDisplay: false,
      // batteryLevel: 0,
      battery_meter: {
        background: "green",
        width: this.level + "%" || "100%",
        height: "100%"
      },
      holderStyle: {
        width: this.width || "100px",
        height: this.height || "30px",
        background: "#eee"
      },
      parentStyle: {
        transform: this.direction == "y" ? "rotate(-90deg)" : ""
      },
      boltStyle: {
        display: "none",
        transform: this.direction == "y" ? "rotate(90deg)" : ""
      },
      statusCalc: true
    };
  },
  watch: {
    timestamp: async function(newVal, old) {
      // console.log(old, newVal);
      // this.batteryLevel = newVal;
      this.timeRightNow = await this.currentTime();
      console.log("Redrawn", this.timeRightNow);
      this.redraw(newVal);
      // this.boltDisplay =
    }
  },
  components: {},
  methods: {
    async currentTime() {
      const me = this;
      const HTTP = this.$httpUtils.instance;
      let response = await HTTP.get(
        "https://arnergy.com/weather-api/time/?" + Date.now()
      );
      if (response) {
        if (response.data.datetime) {
          let tmpDate = response.data.datetime.split(".")[0];
          return tmpDate;
        }
      }
    },
    redraw(timeStmp) {
      this.statusCalc = this.statusIndicator(timeStmp);
      // this.$refs.battery_level.style.background = bg;
    },
    statusIndicator(date) {
      var difference = Math.abs(moment(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    }
  },
  async mounted() {
     console.log("Redrawn", this.timeRightNow);
    // this.timeRightNow = await this.currentTime();
    // this.redraw(this.timeRightNow);
  },
  updated() {}
};
</script>

<style lang="scss" scoped>
// @import "../../../sass/_variables.scss";

$batteryWidth: "100%";
$batteryHeight: "100%";
$batteryBorderSize: 0.3px;
$batteryStrokeColor: rgba(0, 0, 0, 0.3);
$batteryBorderRadius: 2px;
$batteryNubSize: calc(0.5 * #{$batteryHeight});
$nubTopMargin: calc(-0.28 * #{$batteryNubSize});

// .grey-battery-widget{
//   position: relative;
// }
.battery {
  position: relative;
  width: $batteryWidth;
  height: $batteryHeight;
  // border: $batteryBorderSize solid $batteryStrokeColor;
  border-radius: $batteryBorderRadius;
  position: relative;
  z-index: 2;
  // padding: $batteryBorderSize;
  background: $batteryStrokeColor;
  // background-image: linear-gradient(to right, transparent 5%, #316d08 5%, #316d08 7%, #60b939 8%, #60b939 10%, #51aa31 11%, #51aa31 60%, #64ce11 61%, #64ce11 63%, #255405 63%, black 68%, black 95%, transparent 95%), linear-gradient(to bottom, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.4) 4%, rgba(255, 255, 255, 0.2) 7%, rgba(255, 255, 255, 0.2) 14%, rgba(255, 255, 255, 0.8) 14%, rgba(255, 255, 255, 0.2) 40%, rgba(255, 255, 255, 0) 41%, rgba(255, 255, 255, 0) 80%, rgba(255, 255, 255, 0.2) 80%, rgba(255, 255, 255, 0.4) 86%, rgba(255, 255, 255, 0.6) 90%, rgba(255, 255, 255, 0.1) 92%, rgba(255, 255, 255, 0.1) 95%, rgba(255, 255, 255, 0.5) 98%);
  // -webkit-transform: scale(0.5);//for retina display
  display: flex;
  // justify-content: center;
  align-items: center;
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: calc(50% - 2px);
    right: -3px;
    z-index: -1;
    margin-top: #{$nubTopMargin};
    width: 4px;
    height: #{$batteryNubSize};
    background: $batteryStrokeColor;
    // border-top-right-radius: 60%;
    // border-bottom-right-radius: 60%;
  }
  &.mini {
    .warning-bolt {
      font-size: 13px;
    }
  }
  // +.mini{
  &.mini:before {
    top: 50%;
    right: -1.5px;
    width: 3px;
  }
  // }
  &.plugged:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    // right: -1 * calc($batteryBorderSize + calc($batteryWidth * 0.5));
    // margin-top: calc(#{$batteryNubSize} / 2) * -1;
    margin-top: (0.5 * #{$batteryNubSize}) * -1;
    width: #{$batteryNubSize};
    height: #{$batteryNubSize};
    background: #f00;
    border-radius: 50%;
  }
  .level {
    width: 20%;
    height: 100%;
    background: $batteryStrokeColor;
    border-radius: $batteryBorderRadius/2;
    align-self: flex-end;
    display: flex;
  }
  .warning-bolt {
    position: absolute;
    // transform: rotate(90deg);
    font-size: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/status-indicator.vue